import { type ReactNode } from "react";

import { MODE_ENV } from "@/services/constants";

import { adminRoutes } from "./routes/adminRoutes";
import { errorRoutes } from "./routes/errorRoutes";
import { onboardingRoutes } from "./routes/onboardingRoutes";
import { publicRoutes } from "./routes/publicRoutes";
import { restaurantRoutes } from "./routes/restaurantRoutes";

export type RouteConfig = {
  path?: string;
  element?: ReactNode;
  exact?: boolean;
  children?: RouteConfig[];
  index?: boolean;
};

export const ROUTE_CONFIG: RouteConfig[] = [
  ...publicRoutes,
  ...adminRoutes,
  ...onboardingRoutes,
  ...restaurantRoutes,
];

export const ERROR_ROUTE_CONFIG: RouteConfig[] = [...errorRoutes];

const MODE = import.meta.env.VITE_MODE_APP;

export const getRouteConfig = (): RouteConfig[] => {
  if (MODE === MODE_ENV.ADMIN) {
    return [...publicRoutes, ...adminRoutes];
  }

  if (MODE === MODE_ENV.PARTNER) {
    return [...publicRoutes, ...restaurantRoutes];
  }

  return [
    ...publicRoutes,
    ...adminRoutes,
    ...onboardingRoutes,
    ...restaurantRoutes,
  ];
};
